// Option lists and role-based helpers for the Tools page import/export
// sections (kept out of the .jsx files so they only export components)

// Import options arrays
const importFileFormatOptions = [
  { label: "JSON", value: "json" },
  { label: "CSV", value: "csv" },
  { label: "XLSX", value: "xlsx" },
];

const importOptionOptions = [
  { label: "Rebuild", value: "deleteAllAndImport" },
  { label: "Skip Existing Fields", value: "skipExisting" },
  { label: "Replace Existing Fields", value: "replaceExisting" },
];

// Standards Import: which part of a standard's mapping to delete and re-import
const standardsImportFrameworkOptions = [
  { label: "Standard itself", value: "standard" },
  { label: "FundsXML", value: "fundsxml" },
  { label: "openfunds core", value: "openfunds" },
];

// Standard References export: same frameworks as the Standards import
const standardRefsExportFrameworkOptions = [
  { label: "Standard itself", value: "standard" },
  { label: "FundsXML", value: "fundsxml" },
  { label: "openfunds", value: "openfunds" },
];

const standardRefsExportFileFormatOptions = [
  { label: "CSV", value: "csv" },
  { label: "PDF", value: "pdf" },
];

// All possible export file format options
const allExportFileFormatOptions = [
  { label: "JSON", value: "json" },
  { label: "CSV", value: "csv" },
  { label: "XLSX", value: "xlsx" },
  { label: "PDF", value: "pdf" },
  { label: "HTML File", value: "html" },
  { label: "HTML Snippets", value: "snippet" },
];

// Formats available for member role
const memberExportFileFormatOptions = ["json", "csv", "xlsx", "pdf"];

// Formats available for user role
const userExportFileFormatOptions = ["json", "csv"];

// All possible export filter options
const allExportFilterOptions = [
  { label: "Public Fields Only", value: "public" },
  { label: "Public And Internal Fields", value: "all" },
  { label: "Next Versions Only", value: "nextVersions" },
];

// Get allowed file formats based on role
const getExportFileFormatOptions = (isAdmin, isMember) => {
  if (isAdmin()) {
    // Admin: All formats (JSON, CSV, XLSX, PDF, HTML File, HTML Snippets)
    return allExportFileFormatOptions;
  }
  if (isMember()) {
    // Member: JSON, CSV, XLSX, PDF
    return allExportFileFormatOptions.filter((opt) =>
      memberExportFileFormatOptions.includes(opt.value),
    );
  }
  // User: Only JSON and CSV
  return allExportFileFormatOptions.filter((opt) =>
    userExportFileFormatOptions.includes(opt.value),
  );
};

// Get allowed filter options based on role
const getExportFilterOptions = (isAdmin, isMember) => {
  if (isAdmin() || isMember()) {
    // Admin and Member: All filter options
    return allExportFilterOptions;
  }
  // User: Only Public Fields
  return allExportFilterOptions.filter((opt) => opt.value === "public");
};

export {
  importFileFormatOptions,
  importOptionOptions,
  standardsImportFrameworkOptions,
  standardRefsExportFrameworkOptions,
  standardRefsExportFileFormatOptions,
  getExportFileFormatOptions,
  getExportFilterOptions,
};
